/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespCollectionsModules_user = {
    readonly " $fragmentRefs": FragmentRefs<"SbRespCollectionsComponents_user">;
    readonly " $refType": "SbRespCollectionsModules_user";
};
export type SbRespCollectionsModules_user$data = SbRespCollectionsModules_user;
export type SbRespCollectionsModules_user$key = {
    readonly " $data"?: SbRespCollectionsModules_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespCollectionsModules_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespCollectionsModules_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbRespCollectionsComponents_user",
      "args": null
    }
  ]
};
(node as any).hash = 'e1ddf31a066173dddc0b89b41bec86d3';
export default node;
